<template>
	<div>
		<div
			class="mob-back-header d-flex align-items-center justify-content-between"
			id="hideinlaptop"
		>
			<div class="fw-LM fam-lato fs-18 text-black">
				<img
					src="@/assets/img/header/bckarw.svg"
					class="mr-2 pointer"
					alt=""
					@click="goBack"
				/>
				Profile Visibility
			</div>
		</div>
		<div class="cand-dashboard-maincontainer overflow-hidden padding8pxmob">
			<div
				id="hideinmobile"
				class="cand-header d-flex justify-content-between align-items-center"
			>
				<div fw-LM fam-lato fs-18 text-black>
					<img src="@/assets/img/header/bckarw.svg" @click="goBack" class="mr-2 pointer" alt="" />
					Profile Visibility
				</div>
			</div>
			<section
				class="d-flex align-items-center gap-15px pv-main-container mt-3 mobmt0 mobflexcol"
			>
				<section class="w-67 h-100 mobw-100">
					<div
						class="d-flex align-items-center justify-content-between gap-15px mobgap0"
					>
						<div
							class="pv-top-cards d-flex align-items-center gap-15px mobflexcol mobalign-items-unset"
						>
							<div>
								<img
									src="../../assets/newdesign/myprofile/profilevisibility/search.svg"
									alt=""
								/>
							</div>
							<div>
								<div
									class="color-4B5563 fam-lato fw-R fs-14 mobfs-12 mob-fw-500"
								>
									Search Appearance
								</div>
								<div
									class="mt-1 fam-lato fw-800 text-blue fs-20 mob-fs-14 d-flex align-items-center gap-15px"
								>
									{{ profile.profileSearchCount }}
									<span
										class="pv-increase-box d-flex align-items-center justify-content-center fam-lato fw-R fs-12 mob-fs-10"
										:class="
											profile.profileSearchPositive
												? 'color-15803D'
												: 'text-open'
										"
									>
										<img
											:src="
												require(`@/assets/newdesign/myprofile/profilevisibility/${
													profile.profileSearchPositive
														? 'increase'
														: 'decrease'
												}.svg`)
											"
											class="mr-1"
											alt=""
										/>
										{{ profile.profileSearchChangePercent }}%</span
									>
								</div>
							</div>
						</div>
						<div
							class="pv-top-cards d-flex align-items-center gap-15px mobflexcol mobalign-items-unset position-relative"
						>
							<div>
								<img
									src="../../assets/newdesign/myprofile/profilevisibility/profileview.svg"
									alt=""
								/>
							</div>
							<div>
								<div
									class="color-4B5563 fam-lato fw-R fs-14 mobfs-12 mob-fw-500"
								>
									Profile <br id="hideinlaptop" />
									Views
								</div>
								<div
									class="mt-1 fam-lato fw-800 text-blue fs-20 mob-fs-14 d-flex align-items-center gap-15px"
								>
									{{ profile.profileViewCount }}
									<span
										class="pv-increase-box d-flex align-items-center justify-content-center fam-lato fs-12 fw-R mob-fs-10"
										:class="
											profile.profileViewPositive ? 'color-15803D' : 'text-open'
										"
									>
										<img
											:src="
												require(`@/assets/newdesign/myprofile/profilevisibility/${
													profile.profileViewPositive ? 'increase' : 'decrease'
												}.svg`)
											"
											class="mr-1"
											alt=""
										/>
										{{ profile.profileViewChangePercent }}%</span
									>
								</div>
							</div>
							<div
								class="pvdashed-line-vertical position-absolute"
								style="left: -4px; top: 24px"
								id="hideinlaptop"
							></div>
							<div
								class="pvdashed-line-vertical position-absolute"
								style="right: -3px; top: 24px"
								id="hideinlaptop"
							></div>
						</div>
						<div
							class="pv-top-cards d-flex align-items-center gap-15px mobflexcol mobalign-items-unset padding-mob-engagecard"
						>
							<div>
								<img
									src="../../assets/newdesign/myprofile/profilevisibility/engrate.svg"
									alt=""
								/>
							</div>
							<div>
								<div
									class="color-4B5563 fam-lato fw-R fs-14 mobfs-12 mob-fw-500"
								>
									Engagement<br id="hideinlaptop" />
									Rate
								</div>
								<div
									class="mt-1 fam-lato fw-800 text-blue fs-20 d-flex align-items-center gap-15px mob-fs-14"
								>
									{{ profile.engagementRate }}%

									<span
										class="pv-increase-box d-flex align-items-center justify-content-center fam-lato fw-R fs-12 mob-fs-10"
										:class="
											profile.engagementRatePositive
												? 'color-15803D'
												: 'text-open'
										"
									>
										<img
											:src="
												require(`@/assets/newdesign/myprofile/profilevisibility/${
													profile.engagementRatePositive
														? 'increase'
														: 'decrease'
												}.svg`)
											"
											class="mr-1"
											alt=""
										/>

										{{ profile.engagementRateChangePercent }}%
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="pv-right-carousel" id="hideinlaptop">
						<b-carousel
							id="carousel-1"
							:interval="isMobile ? 7000 : 0"
							:controls="isMobile"
							:indicators="isMobile"
							class="hp-carousel-thread"
							img-width="1024"
							img-height="480"
							@sliding-start="onSlideStartImg"
							@sliding-end="onSlideEndImg"
						>
							<b-carousel-slide>
								<div class="pv-resclinic-card mobmt-3">
									<div class="fs-14 fw-M fam-mont color-f1f1f1">
										<img
											src="../../assets/newdesign/myprofile/profilevisibility/resumeclinic.svg"
											alt=""
											class="mr-1"
										/>
										Resume Clinic
									</div>
									<div class="fw-B fs-16 fam-mont text-white my-3">
										Get Instant AI Results on your created Resume!
									</div>
									<b-button
										class="pv-checkbtn candash-cancelBtn pointer"
										@click="openResumeClinicModal"
									>
										Check my Resume
									</b-button>
								</div>
							</b-carousel-slide>
							<b-carousel-slide>
								<div class="pv-recruitercard mt-3 position-relative">
									<img
										src="../../assets/newdesign/myprofile/profilevisibility/premiumtag.svg"
										class="position-absolute bottom-0 right-0"
										style="z-index: -5"
										alt=""
									/>
									<div class="fw-B fs-18 fam-mont text-white text-truncate">
										{{ profile.recruiterViewCount }} + Recruiters have noticed
										you...
									</div>
									<div class="fw-LM fs-14 fam-mont color-E0E0E0 my-3">
										Recruiters may be noticing you. See all your profile views
										now with insights!
									</div>
									<b-button
										class="pv-checkbtn candash-cancelBtn pointer"
										@click="openinterviewModal()"
									>
										Try Premium Now
									</b-button>
								</div></b-carousel-slide
							>
						</b-carousel>
					</div>
					<div class="pv-white-container mt-3 mobw-100 mobmt-0">
						<div
							class="fs-18 fam-mont fw-LM text-black p15px mob-fs-16 mobpb0"
							style="padding: 15px 15px 5px 15px"
						>
							Who’s viewed your profile
						</div>
						<div
							class="fam-mont fw-LM fs-13 text-lightgrey p15px pt-0 mob-fs-12 mobpb0 pr-1"
						>
							Keep your profile updated and active to increase visibility and
							attract more recruiter views.
						</div>
						<section @scroll="onScroll" class="pt-0 p15px pv-card-scroll">
							<div v-for="(view, index) in views" :key="index" class="mt-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="d-flex">
										<div class="pv-card-dp mr-3">
											<img :src="bindProfileImage(index)" class="w-100 h-100" />
										</div>
										<div
											:class="view.tagline ? '' : 'd-flex align-items-center'"
										>
											<div
												v-if="view.viewerName"
												class="fw-M fs-18 fam-mont text-blue mob-fs-14"
											>
												{{ view.viewerName }}
											</div>
											<div
												v-if="view.tagline"
												class="fw-R fs-16 fam-mont color-6b6d70 mob-fs-11"
											>
												{{ view.tagline }}
											</div>
										</div>
									</div>

									<b-button
										class="candash-cancelBtn pointer"
										@click="openinterviewModal()"
										v-if="view.userProfileURL"
									>
										<span id="hideinmobile">View More</span>
										<span id="hideinlaptop">View</span>
									</b-button>
								</div>
								<div
									class="pvdashed-line my-3"
									v-if="index != views.length - 1"
								></div>
							</div>
							<div>
								<div v-if="scroll" class="d-flex justify-content-center">
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</section>
					</div>
				</section>

				<section class="w-33percent h-100 overflow-auto mobw-100">
					<div class="pv-right-carousel" id="hideinmobile">
						<b-carousel
							id="carousel-1"
							:interval="isMobile ? 7000 : 0"
							:controls="isMobile"
							:indicators="isMobile"
							class="hp-carousel-thread"
							img-width="1024"
							img-height="480"
							@sliding-start="onSlideStartImg"
							@sliding-end="onSlideEndImg"
						>
							<b-carousel-slide>
								<div class="pv-resclinic-card mobmt-3">
									<div class="fs-14 fw-M fam-mont color-f1f1f1">
										<img
											src="../../assets/newdesign/myprofile/profilevisibility/resumeclinic.svg"
											alt=""
											class="mr-1"
										/>
										Resume Clinic
									</div>
									<div class="fw-B fs-16 fam-mont text-white my-3">
										Get Instant AI Results on your created Resume!
									</div>
									<b-button
										class="pv-checkbtn candash-cancelBtn pointer"
										@click="openResumeClinicModal"
									>
										Check my Resume
									</b-button>
								</div>
							</b-carousel-slide>
							<b-carousel-slide>
								<div class="pv-recruitercard mt-3 position-relative">
									<img
										src="../../assets/newdesign/myprofile/profilevisibility/premiumtag.svg"
										class="position-absolute bottom-0 right-0"
										style="z-index: -5"
										alt=""
									/>
									<div class="fw-B fs-18 fam-mont text-white text-truncate">
										{{ profile.recruiterViewCount }} + Recruiters have noticed
										you...
									</div>
									<div class="fw-LM fs-14 fam-mont color-E0E0E0 my-3">
										Recruiters may be noticing you. See all your profile views
										now with insights!
									</div>
									<b-button
										class="pv-checkbtn candash-cancelBtn pointer"
										@click="openinterviewModal()"
									>
										Try Premium Now
									</b-button>
								</div></b-carousel-slide
							>
						</b-carousel>
					</div>
					<AsmntTestcards class="mt-3" />
					<InterviewModal :showModal.sync="showInterviewModal" />
					<ResumeClinicModal
						v-if="showresumeclinic"
						:showModal="showresumeclinic"
						@modalClose="modalClose"
						:showfromhelpsection="false"
						:clinicDatafromhs="resumeClinicData"
					/>
				</section>
			</section>
		</div>
	</div>
</template>

<script>
import AsmntTestcards from "@/components/Games/AsmntTestcards.vue";
import { profileView, resumeAnalysis } from "@/utils/apiFunctions.js";
import { getFallbackRecruiterCount } from "@/utils/fallbackViews.js";
import ResumeClinicModal from "@/components/BuilderPage/ResumeclinicModal.vue";
import InterviewModal from "@/components/modal/InterviewModal.vue";

export default {
	data() {
		return {
			page: 0,
			count: 10,
			showBtnText: false,
			scroll: false,
			pageStart: null,
			pageEnd: null,
			total: null,
			showresumeclinic: false,
			resumeClinicData: {},
			sliding: null,
			slide: 0,
			carouselSlides: [],
			temp: [],
			profile: [],
			views: [],
			isMobile: window.innerWidth <= 1028,
			showInterviewModal: false,
		};
	},
	components: {
		AsmntTestcards,
		ResumeClinicModal,
		InterviewModal,
	},
	mounted() {
		window.addEventListener("resize", this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.handleResize);
	},
	created() {
		this.getProfileView();
		if (this.$route.query?.from == "resumeclinicModal") {
			this.resumeAnalysis();
		}
	},
	methods: {
		bindProfileImage(index) {
			return `https://cvstaticfiles.s3.ap-south-1.amazonaws.com/candidate/profilePictureBlurred/profile${
				(index % 26) + 1
			}.png`;
		},
		handleResize() {
			this.isMobile = window.innerWidth <= 991;
		},
		onSlideStartImg(slide) {
			this.sliding = true;
		},
		onSlideEndImg(slide) {
			this.sliding = false;
		},
		async openResumeClinicModal() {
			await this.resumeAnalysis();
			this.showresumeclinic = true;
			this.$router.push({
				query: {
					...this.$route.query, // keep existing params
					fromPage: "ProfileVisibility",
				},
			});
		},
		modalClose() {
			this.showresumeclinic = false;
			if (this.$route.query?.from === "resumeclinicModal") {
				window.history.replaceState({}, "", this.$route.path);
			}
		},
		async resumeAnalysis() {
			try {
				const res = await resumeAnalysis();
				if (res.status == 200) {
					this.resumeClinicData = res.data.data.analysis;
					console.log("this data passed", this.resumeClinicData);

					if (this.$route.query?.from == "resumeclinicModal") {
						this.showresumeclinic = true;
						if (this.$route.query?.fromPage != "ProfileVisibility") {
							this.$router.replace({
								query: {
									...this.$route.query, // keep existing params
									fromPage: "ProfileVisibility",
								},
							});
						}
					}
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getProfileView() {
			let payload = {
				count: this.count,
				page: this.page,
			};
			try {
				const res = await profileView(payload);
				if (res.status == 200) {
					if (this.page == 0) {
						const temp = res.data.data || {};
						this.profile = temp;
						this.views = Array.isArray(temp.views) ? temp.views : [];

						// When the API returns 0 real views, show the same dummy number
						// of viewers that the dashboard displays (so the list matches the
						// "N recruiters viewed your profile" count on the dashboard).
						const realViewCount =
							temp.profileViewCount || temp.recruiterViewCount || 0;
						if (!realViewCount) {
							const dummyCount = getFallbackRecruiterCount();
							this.profile.profileViewCount = dummyCount;
							this.views = Array.from({ length: dummyCount }, () => ({
								viewerName: "Someone viewed your profile",
								tagline: "",
							}));
						}
					} else {
						const newData = res.data.data;

						// Merge only the views array
						this.views = [...this.views, ...newData.views];

						// Update any counts if the API gives updated profile info
						this.profile = {
							...this.profile,
							...newData,
						};
					}

					this.pageStart = res.data.data.pageStart;
					this.pageEnd = res.data.data.pageEnd;
					this.total = res.data.data.total;
					this.scroll = false;
				}
			} catch {
				console.log("error");
			}
		},
		goBack() {
			const prev = sessionStorage.getItem("previousRoute");
			if (prev) {
				this.$router.push(prev);
				sessionStorage.removeItem("previousRoute");
			} else {
				this.$router.go(-1);
			}
		},

		openProfile(url) {
			if (url) {
				window.open(url, "_blank");
			} else {
				console.warn("No profile URL available");
			}
		},
		openinterviewModal() {
			this.showInterviewModal = true;
		},

		async onScroll(e) {
			const { target } = e;
			this.showBtnText = target.scrollTop > 0;
			// Check if the user has reached the bottom of the scrollable area.
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				// Check if there is more data to load.

				if (
					this.checkbetween(this.pageEnd, 0, this.total) &&
					!this.scroll &&
					this.profile.profileViewCount
				) {
					this.scroll = true;
					this.page++;

					await this.getProfileView();
				}
			}
		},
		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},
	},
};
</script>

<style>
@media (min-width: 1029px) {
	/* Disable carousel functionality visuals */
	.pv-right-carousel .carousel-control-prev,
	.pv-right-carousel .carousel-control-next,
	.pv-right-carousel .carousel-indicators {
		display: none !important;
	}

	/* Layout the slides as static cards */
	.pv-right-carousel .carousel-inner {
		display: flex !important;
		flex-direction: column; /* or row if you want them side by side */
		height: auto !important;
	}

	/* Make each slide visible */
	.pv-right-carousel .carousel-item {
		display: block !important;
		opacity: 1 !important;
		transform: none !important;
		position: static !important;
	}

	/* Prevent overflow clipping */
	.pv-right-carousel {
		overflow: visible !important;
		height: auto !important;
	}
	.pv-right-carousel .carousel-caption {
		position: unset;
		text-align: left;
		padding: 0;
	}
}
.pv-white-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100% - 110px);
}
.p15px {
	padding: 15px;
}
.color-15803D {
	color: #15803d;
}
.color-4B5563 {
	color: #4b5563;
}
.pv-main-container {
	height: calc(100vh - 140px);
	display: flex;
	justify-content: center;
	max-width: 1825px;
	width: 100%;
}
.pv-top-cards {
	padding: 16px;
	height: 88px;
	background: #f6f9fd;
	border-radius: 8px;
	width: 33.333%;
}
.gap-15px {
	gap: 15px;
}
.pv-increase-box {
	padding: 4px 10px;
	background: rgba(0, 174, 28, 0.1);
	border-radius: 6px;
}
.w-67 {
	width: 67%;
}
.w-33percent {
	width: 33%;
}
.pv-resclinic-card {
	min-height: 165px;
	height: auto;
	background: url("../../assets/newdesign/myprofile/profilevisibility/resbg.png");
	background-repeat: no-repeat;
	box-shadow: 0px 14.84px 32.1533px rgba(74, 58, 255, 0.07);
	border-radius: 8px;
	padding: 15px;
	background-size: cover;
	width: 99%;
	overflow: hidden;
}
.pv-recruitercard {
	min-height: 165px;
	height: auto;
	width: 99%;
	background: url("../../assets/newdesign/myprofile/profilevisibility/recbg.png");
	background-repeat: no-repeat;
	box-shadow: 0px 14.84px 32.1533px rgba(74, 58, 255, 0.07);
	border-radius: 8px;
	padding: 15px;
	background-size: cover;
	z-index: 1;
	overflow: hidden;
}
.pv-asmntcard {
	background: url("../../assets/newdesign/myprofile/profilevisibility/asmntbg.png");
	background-repeat: no-repeat;
	box-shadow: 0px 14.84px 32.1533px rgba(74, 58, 255, 0.07);
	border-radius: 8px;
	padding: 15px;
	background-size: cover;
}
.pv-card-dp {
	width: 50px;
	height: 50px;
	border-radius: 50%;
	background: rgb(121, 192, 253);
}
.color-6b6d70 {
	color: #6b6c70;
}
.pvdashed-line {
	height: 2px;
	background: repeating-linear-gradient(
		to right,
		#dddddd 0,
		#dddddd 9px,
		transparent 0px,
		transparent 17px
	);
	opacity: 0.5;
}
.color-f1f1f1 {
	color: #f1f1f1;
}
.pv-checkbtn {
	background-color: white !important;
}
.color-E0E0E0 {
	color: #e0e0e0;
}
/* .asmnttest-cards {
	background: rgba(216, 233, 247, 0.8);
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	backdrop-filter: blur(5px);
	border-radius: 5px;
	padding: 9px;
} */
.color-0D47A1 {
	color: #0d47a1;
}
.white-ver-line {
	width: 15px;
	height: 0.04px;
	opacity: 0.9;
	border: 1px solid #d9d9d9;
	transform: rotate(-90deg);
}
.pv-card-scroll {
	height: calc(100vh - 360px);
	overflow: auto;
}
@media (max-width: 1028px) {
	.hp-carousel-thread .carousel-item-next,
	.hp-carousel-thread .carousel-item-prev,
	.hp-carousel-thread .carousel-item.active {
		display: block;
		background-color: transparent !important;
	}

	.hp-carousel-thread .carousel-item-next.carousel-item-left,
	.hp-carousel-thread .carousel-item-prev.carousel-item-right {
		transform: translateX(0px);
	}

	.hp-carousel-thread .carousel-item-left.active {
		transform: translateX(-100%);
	}

	.hp-carousel-thread .carousel-item-right.active {
		transform: translateX(100%);
	}
	.pv-checkbtn {
		padding: 8px 20px !important;
	}
	.mobmt-3 {
		margin-top: 1rem !important;
	}
	.mobmt-0 {
		margin-top: 0 !important;
	}
	.mobgap0 {
		gap: 0px;
	}
	.pv-main-container {
		height: fit-content;
	}
	.cand-dashboard-maincontainer {
		top: 0;
		padding: 15px;
		overflow: auto !important;
	}
	.mobw-100 {
		width: 100% !important;
	}
	.mobpb0 {
		padding-bottom: 0;
	}
	.pv-card-dp {
		height: 36px;
		width: 36px;
	}
	.pv-top-cards {
		height: fit-content;
		width: 100%;
		border-radius: 0px;
	}

	.pvdashed-line-vertical {
		width: 2px;
		height: 125px;
		background: repeating-linear-gradient(
			to bottom,
			#dddddd 0,
			#dddddd 9px,
			transparent 0px,
			transparent 14px
		);
		opacity: 0.5;
	}
	.pv-increase-box {
		padding: 4px 5px;
	}
	.mobmt0 {
		margin-top: 0 !important;
	}
	.pv-white-container {
		background: #ffffff;
		border-radius: 8px;
		height: calc(100dvh - 300px);
		overflow: auto;
	}
	.mobpr0 {
		padding-right: 0;
	}
	.pv-card-scroll {
		height: calc(100% - 70px);
		overflow: auto;
	}
	.mobflexcol {
		flex-direction: column !important;
	}
	.pv-right-carousel .carousel-indicators .active {
		height: 9px !important;
		width: 9px !important;
	}
	.pv-right-carousel .carousel {
		height: 100%;
		width: 100%;
	}

	.pv-right-carousel .carousel-inner {
		height: 100%;
		width: 100%;
	}

	.pv-right-carousel .carousel-item {
		height: 100%;
		width: 100%;
		background: #e9ecef !important;
	}

	.pv-right-carousel .carousel-caption {
		height: 100%;
		width: 100%;
		padding: 0;
		left: 0;
		bottom: 0;
		z-index: 2;
		text-align: unset;
	}

	.pv-right-carousel .carousel-control-prev {
		display: none;
	}

	.pv-right-carousel .carousel-control-next {
		display: none;
	}

	.pv-right-carousel .carousel-indicators {
		display: flex !important;
		align-items: center;
		z-index: 2;
		justify-content: center;
		gap: 3px;
	}
	.pv-right-carousel {
		width: 100%;
		height: 225px;
		border-radius: 8px;
		overflow: hidden;
		flex-shrink: 0;
	}
	.pv-right-carousel .carousel-indicators li {
		width: 7px;
		height: 7px;
		margin-right: 0px;
		margin-left: 0px;
		text-indent: -999px;
		cursor: pointer;
		background-color: #4b81ae;
		background-clip: padding-box;
		border: 1px solid white;
		border-radius: 50%;
		transition: opacity 0.6s ease;
	}
	.mobalign-items-unset {
		align-items: unset !important;
	}
	.padding8pxmob {
		padding: 8px !important;
	}
	.padding-mob-engagecard {
		padding: 16px 5px 16px 16px !important;
	}
}
.w-33 {
	width: 33%;
}
</style>
